import { render, staticRenderFns } from "./TarjetaPartido.vue?vue&type=template&id=c70b3bd6&scoped=true&"
import script from "./TarjetaPartido.vue?vue&type=script&lang=js&"
export * from "./TarjetaPartido.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaPartido.vue?vue&type=style&index=0&id=c70b3bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b3bd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VImg,
})
